import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component, inject } from '@angular/core';

const TRANSLATION_KEY = 'directory_vertimaxcertified_com.header';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  private readonly _language = inject(AccredibleLanguageService);

  headerLinks = [
    {
      id: 'why',
      label: this._language.selectTranslate(TRANSLATION_KEY + '.why'),
      externalLink: 'http://www.vertimax.com/why-vertimax',
    },
  ];
}
